import { AxiosError } from "axios";
import AuthTokenHelper from "helpers/AuthTokenHelper";

export function logOutUserIfTokenInvalid(error: AxiosError): any {
	const originalRequest = error.config;

	if (originalRequest == null) return Promise.reject(error);

	if (error.response?.status === 401) {
		const { data } = error.response;
		if ((data as any).message === "INVALID_TOKEN") {
			AuthTokenHelper.removeAuthToken();
			window.location.href = "/";
			return Promise.reject(error);
		}
	}

	return Promise.reject(error);
}
